import { UserType } from 'types/auth'
import { UserRole } from 'config/userRole'

// Discriminator enum matching APIGW's IdTokenMetadataType
export enum IdTokenMetadataType {
  EGD = 'egd',
  IPIR = 'ipir',
  LOGIN_APP = 'login_app'
}

// EGD end-user metadata
export interface IdTokenMetadata {
  metadataType: IdTokenMetadataType.EGD
  bccAccountId: string
  accountId: string
  domainId: number
  queryString?: string | null
}

// IPIR identity linking metadata
export interface IPIRIdTokenMetadata {
  metadataType: IdTokenMetadataType.IPIR
  bccAccountId: string
  queryString?: string | null
}

// Login App admin metadata
export interface LoginAppIdTokenMetadata {
  metadataType: IdTokenMetadataType.LOGIN_APP
  bccAccountId: string
  queryString?: string | null
  entryPath?: string | null
  loginAppAccessToken?: string | null
  loginAppSessionSecret?: string | null
  isImpersonated?: boolean
  isGuest?: boolean
  authProcessId?: string | null
  // X2: TDF-generated correlation ID for pass check circuit breaker
  correlationId?: string | null
}

// Union type for IdToken.metadata
export type IdTokenMetadataUnion = IdTokenMetadata | IPIRIdTokenMetadata | LoginAppIdTokenMetadata

export enum IdTokenType {
  EGD = 'egd',
  IPIR = 'ipir',
  LOGIN_APP = 'login_app'
}

export interface IdToken {
  iss: string
  sub: string
  type?: IdTokenType | null
  aud: string
  exp: number
  iat: number
  auth_time: number
  nonce: string
  acr?: string | null
  amr?: string | null
  azp?: string | null
  metadata?: IdTokenMetadataUnion | null
}

export enum OAuth2Connection {
  ESS_DB = 'ess_db',
  TEMP_PASSCODE = 'temp_passcode',
  LDAP = 'ldap',
  MS_ENTRA = 'ms_entra',
  TDF = 'tdf',
  IPIR = 'ipir',
  LOGIN_APP = 'login_app'
}

export interface OAuth2ProcessDataPublic {
  id: string
  startedAtIso: string
  availableConnections: OAuth2Connection[]
  queryString: string
}

export interface EGDIdentity {
  preferredUserId: string
  primaryUserId: string | null
  region: string
  domainId: number
  accountId: string
  bccAccountId: string
  isTempPasscodeEnabled: boolean
  isReactEnabled: boolean
  isReactGreenAppEnabled: boolean
  isAzureSsoEnabled: boolean
  userType: UserType
  roleType: UserRole
}

export enum OAuth2Exceptions {
  OAuth2ProcessNotFound = 'OAuth2ProcessNotFound'
}
